import { render, staticRenderFns } from "./user-edit-box.vue?vue&type=template&id=318754fc&scoped=true&"
import script from "./user-edit-box.vue?vue&type=script&lang=js&"
export * from "./user-edit-box.vue?vue&type=script&lang=js&"
import style0 from "./user-edit-box.vue?vue&type=style&index=0&id=318754fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318754fc",
  null
  
)

export default component.exports